
























































import { Component, Mixins, Watch, Prop } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'
import { findIndex } from 'lodash'

import { Meta } from '@/helpers/decorators'

// Mixins
import Errors from '@/mixins/Errors'
import Router from '@/mixins/Router'
import Date from '@/mixins/Date'
import ReportMixin from '@/mixins/Report'

// Components
import ScrollSpy from '@/components/behaviors/ScrollSpy.vue'
import StateTag from '@/components/common/StateTag.vue'
import ModalWrapper from '@/components/common/ModalWrapper.vue'

// Views
import PartBox from '@/views/report/parts/PartBox.vue'
import ReportQrCode from '@/views/report/partials/ReportQrCode.vue'
import AssignReportForm from '@/views/all/forms/AssignReportForm.vue'
import ListAllItems from '@/views/items/partials/ListAllItems.vue'

@Component({
  components: {
    PartBox,
    StateTag,
    ModalWrapper,
    ScrollSpy,
    ReportQrCode,
    ListAllItems,
    AssignReportForm
  }
})
export default class Report extends Mixins(Errors, Router, Date, ReportMixin) {
  loading: boolean = false
  showQRCodeModal = false
  changes = []

  @Getter('token') token
  @Getter('locale', { namespace: 'user' }) locale
  @Action('fetchReport', { namespace: 'report' }) fetchReport
  @Getter('isFinished', { namespace: 'report' }) isFinished

  @Prop() report
  @Prop({ type: Boolean, default: true }) canGoBack

  updateChange(newField) {
    const index = findIndex(this.changes, (field) => field.id === newField.id)
    if (index !== -1) {
      this.changes[index] = newField
    } else {
      this.changes.push(newField)
    }
  }

  saveReport() {
    this.loading = true
    this.$emit('save', this.changes)
  }
}
